module.exports = __webpack_public_path__ + "img/trash-can.9aa2b5ec.svg";